<script setup lang="ts">
import { getStructureDetail } from "@carnet/api/backoffice";
import type { StructureResourceDetailed } from "@carnet/api/backoffice";

const props = defineProps<{
  structureId: string | number;
}>();

const emit = defineEmits<{
  close: [];
}>();

const { t } = useI18n();

const structure = ref<StructureResourceDetailed>();
const loading = ref(true);
const error = ref<string>();

async function load() {
  loading.value = true;
  error.value = undefined;
  try {
    const result = await getStructureDetail({
      composable: "$fetch",
      path: { locale: appLocale(), id: String(props.structureId) },
      headers: { Accept: "application/json" },
    });
    structure.value = result.data;
  } catch {
    structure.value = undefined;
    error.value = t("error.loading");
  } finally {
    loading.value = false;
  }
}

watch(
  () => props.structureId,
  () => load(),
  { immediate: true }
);
</script>

<template>
  <WebMapPopup :loading="loading" :error="error" @close="emit('close')">
    <template #loading>
      <AppTileStructureSkeleton />
    </template>
    <AppTileStructure v-if="structure" :structure="structure" />
  </WebMapPopup>
</template>
